export enum PerformanceAnalysisPeriod {
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
  LAST_60_DAYS = 'last-60-days',
  LAST_90_DAYS = 'last-90-days',
  CUSTOM = 'custom',
}
